import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Layout from '../components/Layout';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './UserList.css'; // <- Add this
import { ADMIN_BASE_URL, API_BASE_URL } from './config';
import './TransactionPopup.css';
import { FaTrash, FaEdit, FaEye, FaEyeSlash } from 'react-icons/fa';
import CustomModal from './CustomModal';
import { toast } from 'react-toastify';
import { FiCopy } from 'react-icons/fi';
import 'react-toastify/dist/ReactToastify.css';
import { ModuleRegistry } from 'ag-grid-community';
import { AllCommunityModule } from 'ag-grid-community';
import MemberIdCell from '../components/MemberIdCell';
import PasswordModal from "../components/PasswordModal";
import Ai2CustomModal from './Ai2CustomModal';
ModuleRegistry.registerModules([AllCommunityModule]);
function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupTransaction, setPopupTransaction] = useState(null);
  const [popupUserId, setPopupUserId] = useState(null);
  const [popupCanConfirm, setPopupCanConfirm] = useState(false);
  const [savingRefer, setSavingRefer] = useState(false);
  const [searchText, setSearchText] = useState('');
  const gridRef = React.useRef();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [manualConfirmOpen, setManualConfirmOpen] = useState(false);
  const [manualConfirmUserId, setManualConfirmUserId] = useState(null);
  const [editReferOpen, setEditReferOpen] = useState(false);
  const [editReferUser, setEditReferUser] = useState(null);
  const [newReferId, setNewReferId] = useState('');
  const [savingReferEdit, setSavingReferEdit] = useState(false);
  const [referredUsersOpen, setReferredUsersOpen] = useState(false);
  const [referredUsersList, setReferredUsersList] = useState([]);
  const [referredByUser, setReferredByUser] = useState(null);
  const [showModals, setShowModals] = useState(false);
  const [revokeUsername, setUsername] = useState(null);
  const [revokeEmail, setEmail] = useState(null);
  const [pendingAction, setPendingAction] = useState(null);
  // For Ai2 user
  const [ai2Users, setAi2Users] = useState([]);
  const [showAi2Modal, setShowAi2Modal] = useState(false);

  // Tab state for admin users
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'ai2' , 'free', 'verify'
  // Get user role and ID from localStorage
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  const isCallCenter = localStorage.getItem('isCallCenter') === '1';
  const currentUserId = localStorage.getItem('userId');
  const isPaid = localStorage.getItem('isConfirm');
  const isAdminUser = isAdmin || isCallCenter;
  const [editUser, setEditUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [editForm, setEditForm] = useState({
    user_name: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    password: '',
  });
  const handleConfirmPassword = async (password) => {
    if (password !== "333333333") {
      toast.error('Password Mismatch');
      return false;
    }

    // ✅ If password correct, call the freeze API
    if (pendingAction) {
      await pendingAction();
      setPendingAction(null);
    }
    setShowModals(false);
    return true;
  };
  const handleRequestFreeze = (userId, action, username, emails, apiCall) => {
    // console.log("username freezew",username)
    // console.log("email freezew",emails)
    setPendingAction(() => () => apiCall(userId, action)); // store fn to call later
    setShowModals(true); // open modal
    setUsername(username);
    setEmail(emails);
  };
  // console.log("isPaid",isPaid)
  // Inside TransactionPopup component

  // Helper function to refresh users based on role
  // const refreshUsers = async () => {
  //   setLoading(true);
  //   try {
  //     let response;
  //     if (isAdminUser) {
  //       response = await fetch(`${ADMIN_BASE_URL}/adminapi/users`);
  //     } else {
  //       response = await fetch(`${API_BASE_URL}/referred-users/${currentUserId}`);
  //     }
  //     const data = await response.json();
  //     // console.log("data: ",data);
  //     setUsers(data);
  //     setFilteredUsers(data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Error refreshing users:', error);
  //     setLoading(false);
  //   }
  // };

  const refreshUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
      // 🔹 Fetch AI2 users ALWAYS (for count)
      if (isAdminUser) {
        const ai2Res = await fetch(`${API_BASE_URL}/ai2/ai2_users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        const ai2Data = await ai2Res.json();
        setAi2Users(Array.isArray(ai2Data?.users) ? ai2Data?.users : []);
      }

      // 🔹 Fetch main users based on role
      let res;
      if (isAdminUser) {
        res = await fetch(`${ADMIN_BASE_URL}/adminapi/users`);
      }

      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);

    } catch (err) {
      console.error(err);
      setUsers([]);
      setAi2Users([]);
    } finally {
      setLoading(false);
    }
  };

  // Function to filter users based on active tab
  const getFilteredUsersByTab = () => {
    if (!isAdmin) return users;

    switch (activeTab) {
      case 'free':
        return users.filter(user => {
          const { transaction, is_confirmation } = user;
          // Free members: no transaction AND not manually confirmed as paid
          return !transaction && is_confirmation !== 1;
        });
      case 'verify':
        return users.filter(user => {
          const { transaction, is_confirmation } = user;
          // Verify payment: has transaction but not confirmed
          return transaction && is_confirmation !== 1;
        });
      case 'ai2':
        return users.filter(user => user.user_type === 'ai2_user'); // Filter for AI2 users
      default:
        return users; // 'all' tab shows all users
    }
  };

  // Function to get user counts for each tab
  const getUserCounts = () => ({
    all: users.length,
    free: users.filter(u => !u.transaction && u.is_confirmation !== 1).length,
    verify: users.filter(u => u.transaction && u.is_confirmation !== 1).length,
    ai2: ai2Users.length, // ✅ ALWAYS AVAILABLE
  });

  useEffect(() => {
    refreshUsers();
    console.log("TEST++++", ai2Users)
  }, [isAdminUser, currentUserId]);

  const handleEditRefer = (user) => {
    setEditReferUser(user);
    setNewReferId(user.user_refer_id || '');
    setEditReferOpen(true);
  };

  const handleSaveReferEdit = async () => {
    setSavingReferEdit(true);
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${ADMIN_BASE_URL}/adminapi/users/${editReferUser.id}/editrefer`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ userReferId: newReferId }),
        }
      );
      const result = await response.json();
      if (response.ok) {
        toast.success('Referral updated successfully.');
        setEditReferOpen(false);
        setEditReferUser(null);
        setNewReferId('');
        // Refresh user list
        refreshUsers();
      } else {
        toast.error(result.message || 'Failed to update referral.');
      }
    } catch (err) {
      toast.error('Network error. Please try again.');
    }
    setSavingReferEdit(false);
  };

  // const handleRowClick = (data) => {
  //   const allUsers = filteredUsers || [];
  //   const dsUser = allUsers?.find(u => u.id === data.ds_id);
  //   const finalDsUser = dsUser ? dsUser.user_name : "";
  //   setSelectedRowData({ ...data, dsSponsor: finalDsUser });
  //   setShowModal(true);
  // };

  const handleRowClick = (data) => {
    setSelectedRowData(data);

    if (activeTab === "ai2") {
      // 🔹 AI2 TAB → OPEN AI2 MODAL
      setShowAi2Modal(true);
    } else {
      // 🔹 ALL / OTHER TABS → OPEN NORMAL MODAL
      const allUsers = filteredUsers || [];
      const dsUser = allUsers.find(u => u.id === data.ds_id);
      const finalDsUser = dsUser ? dsUser.user_name : "";

      setSelectedRowData({ ...data, dsSponsor: finalDsUser });
      setShowModal(true);
    }
  };

  const handleConfirmManual = async (userId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${ADMIN_BASE_URL}/adminapi/users/${userId}/confirm`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        toast.success('User payment manually confirmed.');
        // Refresh user list
        refreshUsers();
      } else {
        toast.error(result.message || 'Failed to confirm payment.');
      }
    } catch (err) {
      toast.error('Network error. Please try again.');
    }
  };
  const handleRevertPayment = async (userId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${ADMIN_BASE_URL}/adminapi/users/${userId}/revertManualPayment`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        toast.success('User payment reverted successfully.');
        // Refresh user list
        refreshUsers();
      } else {
        toast.error(result.message || 'Failed to revert payment.');
      }
    } catch (err) {
      toast.error('Network error. Please try again.');
    }
  };

  const handleView = (transaction, userId, canConfirm) => {
    setPopupTransaction(transaction);
    setPopupUserId(userId);
    setPopupCanConfirm(canConfirm);
    setPopupOpen(true);
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    const token = localStorage.getItem('token');
    try {
      const deleteUrl =
        activeTab === 'ai2'
          ? `${API_BASE_URL}/ai2/user/${userId}`
          : `${ADMIN_BASE_URL}/adminapi/users/${userId}`

      const response = await fetch(deleteUrl,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        alert('User deleted successfully.');
        refreshUsers();
      } else {
        alert(result.message || 'Failed to delete user.');
      }
    } catch (err) {
      alert('Network error. Please try again.');
    }
  };

  const handleSaveRefer = async (referId, forDSAssignment = false) => {
    setSavingRefer(true);
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${ADMIN_BASE_URL}/adminapi/users/${popupUserId}/refer`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ userReferId: referId }),
        }
      );
      const result = await response.json();
      if (response.ok) {
        alert(forDSAssignment ? 'DR successfully assigned to DS.' : 'Referral saved successfully.');
        setPopupOpen(false);
        // Refresh user list
        refreshUsers();
      } else {
        alert(result.message || 'Failed to save referral.');
      }
    } catch (err) {
      alert('Network error. Please try again.');
    }
    setSavingRefer(false);
  };

  const handleConfirm = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(
        `${ADMIN_BASE_URL}/adminapi/users/${popupUserId}/confirm`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        alert('User confirmed successfully.');
        setPopupOpen(false);
        // Optionally refresh user list
        refreshUsers();
      } else {
        alert(result.message || 'Failed to confirm user.');
      }
    } catch (err) {
      alert('Network error. Please try again.');
    }
  };


  const handleEdit = (user) => {
    console.log(user, "user");

    setEditUser(user);
    setEditForm({
      user_name: user.user_name || '',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      phone_number: user.phone_number || '',
      email: user.email || '',
      password: user.password || '',
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({ ...prev, [name]: value }));
  };

  const handleEditFormSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    const payload = { ...editForm };
    if (!payload.password) delete payload.password;

    try {
      const response = await fetch(`${ADMIN_BASE_URL}/adminapi/user/${editUser.id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editForm),
      });
      const result = await response.json();
      if (response.ok) {
        alert('User updated successfully.');
        setEditUser(null);
        refreshUsers();
      } else {
        alert(result.message || 'Failed to update user.');
      }
    } catch {
      alert('Network error. Please try again.');
    }
  };


  useEffect(() => {
    let baseUsers = [];

    // 🔹 Choose correct base dataset
    if (activeTab === 'ai2') {
      baseUsers = ai2Users;
    } else {
      baseUsers = users;
    }

    // 🔹 Apply tab filtering (free / verify)
    let tabFilteredUsers =
      activeTab === 'ai2'
        ? baseUsers
        : getFilteredUsersByTab();

    // 🔹 Skip date filtering for AI2
    if (activeTab === 'ai2' || (!fromDate && !toDate)) {
      setFilteredUsers(tabFilteredUsers);
      return;
    }

    // 🔹 Date filtering (NON-AI2 only)
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const result = tabFilteredUsers.filter(user => {
      if (!user.user_created_at) return false;

      const createdDate = new Date(user.user_created_at);

      if (from) {
        const fromStart = new Date(from);
        fromStart.setHours(0, 0, 0, 0);
        if (createdDate < fromStart) return false;
      }

      if (to) {
        const toEnd = new Date(to);
        toEnd.setHours(23, 59, 59, 999);
        if (createdDate > toEnd) return false;
      }

      return true;
    });

    setFilteredUsers(result);
  }, [fromDate, toDate, users, ai2Users, activeTab]);


  const handleExportByDateRange = () => {
    if (gridRef.current?.api) {
      const csv = gridRef.current.api.getDataAsCsv({
        onlySelected: false,
        allColumns: true,
      });

      // Download manually
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'users-list.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Define column definitions based on user role
  const getColumnDefs = () => {
    console.log("isAdmin >>> ", isAdmin)
    console.log("isCallCenter >>> ", isCallCenter)

    if (isAdmin) {
      console.log("going inside isAdmin >>>> ")
      // Admin users see all columns
      return [
        {
          headerName: "ID",
          colId: "memberId",
          valueGetter: params => {
            if (!params.data.user_created_at) return '';
            const allUsers = params.context?.allUsers || [];
            const sortedUsers = [...allUsers].sort((a, b) =>
              new Date(a.user_created_at) - new Date(b.user_created_at)
            );
            const index = sortedUsers.findIndex(user => user.id === params.data.id);
            return (index + 1).toString().padStart(4, '0');
          },
          flex: 1,
          minWidth: 60,
          cellRenderer: (params) => (
            <MemberIdCell
              value={params.value}
              data={params.data}
              onRefresh={refreshUsers}
              onFreezeRequest={(userId, action, usernames, emails, apiCall) =>
                handleRequestFreeze(userId, action, usernames, emails, apiCall)
              }
            />
          ),
          cellStyle: { textAlign: "" },
        },
        {
          headerName: "User Name",
          field: "user_name",
          flex: 1,
          minWidth: 120,
          tooltipField: "user_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          cellRenderer: (params) => {
            return (
              <span
                onClick={() => handleRowClick(params?.data)}
                style={{
                  color: '#1976d2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
                title="View Details"
              >
                {params.value}
              </span>
            );
          }
        },
        {
          headerName: "First Name", field: "first_name", flex: 1, minWidth: 100, tooltipField: "first_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
        {
          headerName: "Last Name", field: "last_name", flex: 1, minWidth: 100, tooltipField: "last_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
        // {
        //   headerName: "Phone",
        //   field: "phone_number",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value}</span>
        //         <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Email",
        //   field: "email",
        //   flex: 1,
        //   minWidth: 250,
        //   cellStyle: {
        //     overflow: "hidden",
        //     textOverflow: "ellipsis",
        //     whiteSpace: "nowrap",
        //   },
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value}</span>
        //         <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Street Address",
        //   field: "streetAddress",
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Street Address 2",
        //   field: "streetAddress2",
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "City",
        //   field: "city",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "State",
        //   field: "state",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Province",
        //   field: "province",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Country",
        //   field: "country",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Zip Code",
        //   field: "zip",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        {
          headerName: "Referred By",
          field: "user_refer_id",
          flex: 1,
          minWidth: 180,
          cellRenderer: (params) => {
            const allUsers = params.context?.allUsers || [];
            const referredUser = allUsers?.find(u => u.id === params.data.user_refer_id);
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{referredUser ? referredUser.user_name : ""}</span>
                <FaEdit
                  style={{ color: "#1976d2", cursor: "pointer" }}
                  title="Edit Referred By"
                  onClick={() => params.context.handleEditRefer(params.data)}
                />
              </div>
            );
          }
        },
        {
          headerName: "TXC Wallet",
          field: "txc_coin_wallet_address",
          flex: 1,
          minWidth: 120,
          valueGetter: (params) => {
            const { txc_coin_wallet_address } = params.data;

            if (txc_coin_wallet_address !== null && txc_coin_wallet_address !== "") return "YES";
            return "No";
          },
          cellStyle: params => {
            const status = params.value;

            if (status === "YES") return { color: "#43e97b", fontWeight: 700 };

            return { color: "#e53935", fontWeight: 700 };
          },
        },

        // {
        //   headerName: "DS Sponsor",
        //   field: "ds_id",
        //   flex: 1,
        //   minWidth: 180,
        //   valueGetter: params => {
        //     // Find the user whose id matches ds_id
        //     const allUsers = params.context?.allUsers || [];
        //     const dsUser = allUsers?.find(u => u.id === params.data.ds_id);
        //     return dsUser ? dsUser.user_name : "";
        //   }
        // },
        // {
        //   headerName: "Transaction Id",
        //   field: "transactionId", // optional: you can keep any main field name
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {
        //     // Define possible fields
        //     const possibleFields = [
        //       params.data?.btc_transaction,
        //       params.data?.eth_transaction,
        //       params.data?.usdt_transaction,
        //     ];

        //     // Find the first non-null, non-empty value
        //     const displayValue = possibleFields.find(v => v !== null && v !== undefined && v !== "") || "-";

        //     const handleCopy = () => {
        //       if (displayValue && displayValue !== "N/A") {
        //         navigator.clipboard.writeText(displayValue);
        //         toast.success("Copied to clipboard!");
        //       } else {
        //         toast.error("Nothing to copy");
        //       }
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{displayValue}</span>
        //         {displayValue && displayValue !== "-" && (
        //           <button
        //             onClick={handleCopy}
        //             style={{
        //               marginLeft: "8px",
        //               cursor: "pointer",
        //               border: "none",
        //               background: "none"
        //             }}
        //             title="Copy"
        //           >
        //             <FiCopy size={15} color="#333" />
        //           </button>
        //         )}
        //       </div>
        //     );
        //   }
        // },
        {
          headerName: "TXC Status",
          field: "payment_status",
          flex: 1,
          valueGetter: (params) => {
            const { transaction, is_confirmation } = params.data;
            // console.log("Transaction:", transaction, "Confirmation Status:", is_confirmation);
            if (transaction && is_confirmation === 1) return "Paid";
            if (transaction && is_confirmation !== 1) return "Verify Payment";
            if (is_confirmation === 1) return "Manual Paid";
            return "Not Paid";
          },
          cellStyle: params => {
            const status = params.value;
            if (status === "Paid") return { color: "#43e97b", fontWeight: 700 };
            if (status === "Verify Payment") return { color: "#ff9800", fontWeight: 700 };
            if (status === "Manual Paid") return { color: "#43e97b", fontWeight: 700 };

            return { color: "#e53935", fontWeight: 700 };
          },
          minWidth: 100
        },
        {
          headerName: "DRs Status",
          field: "drs_payment_status",
          flex: 1,
          valueGetter: (params) => {
            // const { transaction, is_confirmation } = params.data;
            // // console.log("Transaction:", transaction, "Confirmation Status:", is_confirmation);
            // if (transaction && is_confirmation === 1) return "Paid";
            // if (transaction && is_confirmation !== 1) return "Verify Payment";
            // if (is_confirmation === 1) return "Manual Paid";
            return "Not Paid";
          },
          cellStyle: params => {
            // const status = params.value;
            // if (status === "Paid") return { color: "#43e97b", fontWeight: 700 };
            // if (status === "Verify Payment") return { color: "#ff9800", fontWeight: 700 };
            // if (status === "Manual Paid") return { color: "#43e97b", fontWeight: 700 };

            return { color: "#e53935", fontWeight: 700 };
          },
          minWidth: 100
        },
        {
          headerName: "Action",
          cellRenderer: (params) => {
            const { transaction, id, is_confirmation, ds_id } = params.data;

            let paymentStatus = "Not Paid";
            if (is_confirmation === 1) paymentStatus = "Paid";
            else if (transaction && is_confirmation !== 1) paymentStatus = "Verify Payment";

            let btnText = "View";
            let btnColor = "#1976d2";
            let disabled = false;

            if (paymentStatus === "Paid") {
              if (ds_id != null && ds_id !== 0) {
                btnText = "DS Assigned";
                btnColor = "#808080";

              } else {
                btnText = "Assign DS";
                btnColor = "#43e97b";
              }
            } else if (paymentStatus === "Verify Payment") {
              btnText = "Verify";
              btnColor = "#ff9800";
            } else {
              if (paymentStatus === "Not Paid") {
                btnText = "Not Paid";
                btnColor = "#e53935";
              }
            }
            return (
              <>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div style={{
                    display: "flex", gap: "5px"
                  }}>
                    <button
                      className="view-btn"
                      style={{
                        marginLeft: 8,
                        background: btnColor,
                        width: "120px",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "7px 18px",
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: disabled ? "not-allowed" : "pointer",
                        opacity: disabled ? 0.7 : 1,
                      }}
                      onClick={() => {
                        if (paymentStatus === "Not Paid") {
                          setManualConfirmUserId(id);
                          setManualConfirmOpen(true);
                        } else if (!disabled) {
                          params.context.handleView(
                            transaction,
                            id,
                            !!transaction && is_confirmation !== 1
                          );
                        }
                      }}
                      disabled={disabled}
                    >
                      {btnText}
                    </button>
                    {(!transaction && is_confirmation === 1) && <button className="view-btn"
                      style={{
                        marginLeft: 8,
                        background: "#D1B200",
                        // width: "120px",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "7px 8px",
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: disabled ? "not-allowed" : "pointer",
                        opacity: disabled ? 0.7 : 1,
                      }}
                      onClick={() => handleRevertPayment(id)}>Revert Payment</button>}
                  </div>

                  <button
                    onClick={() => handleEdit(params.data)}
                    style={iconBtnStyle('#1976d2')}
                    title="Edit User"
                  >
                    <FaEdit />
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => params.context.handleDelete(id)}
                    title="Delete User"
                    style={iconBtnStyle('#1976d2')}
                  >
                    <FaTrash />
                  </button>
                </div>
              </>
            );
          },
          minWidth: 350,
        },
        {
          headerName: "Qty. Referred",
          field: "referral_count",
          flex: 1,
          minWidth: 80,
          cellRenderer: (params) => {
            const allUsers = params.context?.allUsers || [];
            const referredUsers = allUsers.filter(u => u.user_refer_id === params.data.id);
            const count = referredUsers.length;
            return (
              <span
                style={{
                  color: count > 0 ? "#1976d2" : "#333",
                  textDecoration: count > 0 ? "underline" : "none",
                  cursor: count > 0 ? "pointer" : "default",
                  fontWeight: 600,
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center"
                }}
                onClick={() => {
                  if (count > 0) {
                    setReferredUsersList(referredUsers);
                    setReferredByUser(params.data);
                    setReferredUsersOpen(true);
                  }
                }}
                title={count > 0 ? "View referred users" : ""}
              >
                {count}
              </span>
            );
          },
          cellStyle: { textAlign: 'center', fontWeight: 600 },
        },
        {
          headerName: "Created Date",
          field: "user_created_at",
          filter: "agDateColumnFilter",
          sortable: true,
          flex: 1,
          valueFormatter: (params) =>
            params.value ? new Date(params.value).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }) : "—",
          filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) => {
              const cellDate = new Date(cellValue);
              const cellDateOnly = new Date(
                cellDate.getFullYear(),
                cellDate.getMonth(),
                cellDate.getDate()
              );
              if (cellDateOnly < filterLocalDateAtMidnight) return -1;
              if (cellDateOnly > filterLocalDateAtMidnight) return 1;
              return 0;
            },
            browserDatePicker: true,
          },
          minWidth: 100
        },
      ];
    } else {
      // Call Center Columns
      console.log("going inside callcenter >>>> ")
      return [
        {
          headerName: "Member ID",
          field: "id",
          colId: "memberId",
          // valueGetter: params => {
          //   console.log("params ID >>> ", params)
          //   if (!params.data.user_created_at) return '';
          //   const allUsers = params.context?.allUsers || [];
          //   const sortedUsers = [...allUsers].sort((a, b) =>
          //     new Date(a.user_created_at) - new Date(b.user_created_at)
          //   );
          //   const index = sortedUsers.findIndex(user => user.id === params.data.id);
          //   return (index + 1).toString().padStart(4, '0');
          // },
          flex: 1,
          minWidth: 60,
          cellRenderer: (params) => (
            <MemberIdCell
              value={params.value}
              data={params.data}
              onRefresh={refreshUsers}
              onFreezeRequest={(userId, action, usernames, emails, apiCall) =>
                handleRequestFreeze(userId, action, usernames, emails, apiCall)
              }
            />
          ),
          cellStyle: { textAlign: "" },
        },
        {
          headerName: "User Name",
          field: "user_name",
          flex: 1,
          minWidth: 120,
          tooltipField: "user_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          cellRenderer: (params) => {
            return (
              <span
                onClick={() => handleRowClick(params?.data)}
                style={{
                  color: '#1976d2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
                title="View Details"
              >
                {params.value}
              </span>
            );
          }
        },
        {
          headerName: "Firsts Name", field: "first_name", flex: 1, minWidth: 100, tooltipField: "first_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
        {
          headerName: "Last Name", field: "last_name", flex: 1, minWidth: 100, tooltipField: "last_name",
          cellStyle: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
        // {
        //   headerName: "Phone",
        //   field: "phone_number",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value}</span>
        //         <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Email",
        //   field: "email",
        //   flex: 1,
        //   minWidth: 250,
        //   cellStyle: {
        //     overflow: "hidden",
        //     textOverflow: "ellipsis",
        //     whiteSpace: "nowrap",
        //   },
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value}</span>
        //         <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Street Address",
        //   field: "streetAddress",
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Street Address 2",
        //   field: "streetAddress2",
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "City",
        //   field: "city",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "State",
        //   field: "state",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {
        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Province",
        //   field: "province",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Country",
        //   field: "country",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        // {
        //   headerName: "Zip Code",
        //   field: "zip",
        //   flex: 1,
        //   minWidth: 150,
        //   cellRenderer: (params) => {

        //     const handleCopy = () => {
        //       navigator.clipboard.writeText(params.value);
        //       toast.success("Copied to clipboard!");
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{params.value || "-"}</span>
        //         {params.value && <button
        //           onClick={handleCopy}
        //           style={{
        //             marginLeft: "8px",
        //             cursor: "pointer",
        //             border: "none",
        //             background: "none"
        //           }}
        //           title='Copy'
        //         >
        //           <FiCopy size={15} color="#333" />
        //         </button>}
        //       </div>
        //     );
        //   }
        // },
        {
          headerName: "Created Date",
          field: "user_created_at",
          filter: "agDateColumnFilter",
          sortable: true,
          flex: 1,
          valueFormatter: (params) => {
            console.log("params Created DATE >>> ", params);
            // return params.value ? new Date(params.value).toLocaleDateString('en-US', {
            //   year: 'numeric',
            //   month: '2-digit',
            //   day: '2-digit'
            // }) : "—";
            return params.value ? new Date(params.value).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }) : "—";
          },
          filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) => {
              const cellDate = new Date(cellValue);
              const cellDateOnly = new Date(
                cellDate.getFullYear(),
                cellDate.getMonth(),
                cellDate.getDate()
              );
              if (cellDateOnly < filterLocalDateAtMidnight) return -1;
              if (cellDateOnly > filterLocalDateAtMidnight) return 1;
              return 0;
            },
            browserDatePicker: true,
          },
          minWidth: 100
        },
        {
          headerName: "Referred By",
          field: "user_refer_id",
          flex: 1,
          minWidth: 180,
          cellRenderer: (params) => {
            const allUsers = params.context?.allUsers || [];
            const referredUser = allUsers?.find(u => u.id === params.data.user_refer_id);
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{referredUser ? referredUser.user_name : ""}</span>
                {/* <FaEdit
                  style={{ color: "#1976d2", cursor: "pointer" }}
                  title="Edit Referred By"
                  onClick={() => params.context.handleEditRefer(params.data)}
                /> */}
              </div>
            );
          }
        },

        // {
        //   headerName: "DS Sponsor",
        //   field: "ds_id",
        //   flex: 1,
        //   minWidth: 180,
        //   valueGetter: params => {
        //     // Find the user whose id matches ds_id
        //     const allUsers = params.context?.allUsers || [];
        //     const dsUser = allUsers?.find(u => u.id === params.data.ds_id);
        //     return dsUser ? dsUser.user_name : "";
        //   }
        // },
        // {
        //   headerName: "Transaction Id",
        //   field: "transactionId", // optional: you can keep any main field name
        //   flex: 1,
        //   minWidth: 250,
        //   cellRenderer: (params) => {
        //     // Define possible fields
        //     const possibleFields = [
        //       params.data?.btc_transaction,
        //       params.data?.eth_transaction,
        //       params.data?.usdt_transaction,
        //     ];

        //     // Find the first non-null, non-empty value
        //     const displayValue = possibleFields.find(v => v !== null && v !== undefined && v !== "") || "-";

        //     const handleCopy = () => {
        //       if (displayValue && displayValue !== "N/A") {
        //         navigator.clipboard.writeText(displayValue);
        //         toast.success("Copied to clipboard!");
        //       } else {
        //         toast.error("Nothing to copy");
        //       }
        //     };

        //     return (
        //       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        //         <span>{displayValue}</span>
        //         {displayValue && displayValue !== "-" && (
        //           <button
        //             onClick={handleCopy}
        //             style={{
        //               marginLeft: "8px",
        //               cursor: "pointer",
        //               border: "none",
        //               background: "none"
        //             }}
        //             title="Copy"
        //           >
        //             <FiCopy size={15} color="#333" />
        //           </button>
        //         )}
        //       </div>
        //     );
        //   }
        // },
        {
          headerName: "TXC Status",
          field: "payment_status",
          flex: 1,
          valueGetter: (params) => {
            const { transaction, is_confirmation } = params.data;
            // console.log("Transaction:", transaction, "Confirmation Status:", is_confirmation);
            if (transaction && is_confirmation === 1) return "Paid";
            if (transaction && is_confirmation !== 1) return "Verify Payment";
            if (is_confirmation === 1) return "Manual Paid";
            return "Not Paid";
          },
          cellStyle: params => {
            const status = params.value;
            if (status === "Paid") return { color: "#43e97b", fontWeight: 700 };
            if (status === "Verify Payment") return { color: "#ff9800", fontWeight: 700 };
            if (status === "Manual Paid") return { color: "#43e97b", fontWeight: 700 };

            return { color: "#e53935", fontWeight: 700 };
          },
          minWidth: 100
        },
        // {
        //   headerName: "DRs Status",
        //   field: "drs_payment_status",
        //   flex: 1,
        //   valueGetter: (params) => {
        //     const { transaction, is_confirmation } = params.data;
        //     // console.log("Transaction:", transaction, "Confirmation Status:", is_confirmation);
        //     if (transaction && is_confirmation === 1) return "Paid";
        //     if (transaction && is_confirmation !== 1) return "Verify Payment";
        //     if (is_confirmation === 1) return "Manual Paid";
        //     return "Not Paid";
        //   },
        //   cellStyle: params => {
        //     const status = params.value;
        //     if (status === "Paid") return { color: "#43e97b", fontWeight: 700 };
        //     if (status === "Verify Payment") return { color: "#ff9800", fontWeight: 700 };
        //     if (status === "Manual Paid") return { color: "#43e97b", fontWeight: 700 };

        //     return { color: "#e53935", fontWeight: 700 };
        //   },
        //   minWidth: 100
        // },
        // {
        //   headerName: "Action",
        //   cellRenderer: (params) => {
        //     const { transaction, id, is_confirmation, ds_id } = params.data;

        //     let paymentStatus = "Not Paid";
        //     if (is_confirmation === 1) paymentStatus = "Paid";
        //     else if (transaction && is_confirmation !== 1) paymentStatus = "Verify Payment";

        //     let btnText = "View";
        //     let btnColor = "#1976d2";
        //     let disabled = false;

        //     if (paymentStatus === "Paid") {
        //       if (ds_id != null && ds_id !== 0) {
        //         btnText = "DS Assigned";
        //         btnColor = "#808080";

        //       } else {
        //         btnText = "Assign DS";
        //         btnColor = "#43e97b";
        //       }
        //     } else if (paymentStatus === "Verify Payment") {
        //       btnText = "Verify";
        //       btnColor = "#ff9800";
        //     } else {
        //       if (paymentStatus === "Not Paid") {
        //         btnText = "Not Paid";
        //         btnColor = "#e53935";
        //       }
        //     }
        //     return (
        //       <>
        //         <div style={{ display: 'flex', gap: '10px' }}>
        //           <div style={{
        //             display: "flex", gap: "5px"
        //           }}>
        //             <button
        //               className="view-btn"
        //               style={{
        //                 marginLeft: 8,
        //                 background: btnColor,
        //                 width: "120px",
        //                 color: "#fff",
        //                 border: "none",
        //                 borderRadius: 6,
        //                 padding: "7px 18px",
        //                 fontWeight: 600,
        //                 fontSize: 15,
        //                 cursor: disabled ? "not-allowed" : "pointer",
        //                 opacity: disabled ? 0.7 : 1,
        //               }}
        //               onClick={() => {
        //                 if (paymentStatus === "Not Paid") {
        //                   setManualConfirmUserId(id);
        //                   setManualConfirmOpen(true);
        //                 } else if (!disabled) {
        //                   params.context.handleView(
        //                     transaction,
        //                     id,
        //                     !!transaction && is_confirmation !== 1
        //                   );
        //                 }
        //               }}
        //               disabled={disabled}
        //             >
        //               {btnText}
        //             </button>
        //             {is_confirmation === 1 && <button className="view-btn"
        //               style={{
        //                 marginLeft: 8,
        //                 background: "#D1B200",
        //                 // width: "120px",
        //                 color: "#fff",
        //                 border: "none",
        //                 borderRadius: 6,
        //                 padding: "7px 8px",
        //                 fontWeight: 600,
        //                 fontSize: 15,
        //                 cursor: disabled ? "not-allowed" : "pointer",
        //                 opacity: disabled ? 0.7 : 1,
        //               }}
        //               onClick={() => handleRevertPayment(id)}>Revert Payment</button>}
        //           </div>

        //           <button
        //             onClick={() => handleEdit(params.data)}
        //             style={iconBtnStyle('#1976d2')}
        //             title="Edit User"
        //           >
        //             <FaEdit />
        //           </button>
        //           <button
        //             className="delete-btn"
        //             onClick={() => params.context.handleDelete(id)}
        //             title="Delete User"
        //             style={iconBtnStyle('#1976d2')}
        //           >
        //             <FaTrash />
        //           </button>
        //         </div>
        //       </>
        //     );
        //   },
        //   minWidth: 350,
        // },
        {
          headerName: "Qty. Referred",
          field: "referral_count",
          flex: 1,
          minWidth: 80,
          cellRenderer: (params) => {
            const allUsers = params.context?.allUsers || [];
            const referredUsers = allUsers.filter(u => u.user_refer_id === params.data.id);
            const count = referredUsers.length;
            return (
              <span
                style={{
                  color: count > 0 ? "#1976d2" : "#333",
                  textDecoration: count > 0 ? "underline" : "none",
                  cursor: count > 0 ? "pointer" : "default",
                  fontWeight: 600,
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center"
                }}
                onClick={() => {
                  if (count > 0) {
                    setReferredUsersList(referredUsers);
                    setReferredByUser(params.data);
                    setReferredUsersOpen(true);
                  }
                }}
                title={count > 0 ? "View referred users" : ""}
              >
                {count}
              </span>
            );
          },
          cellStyle: { textAlign: 'center', fontWeight: 600 },
        },
      ];
    }
  };

  const columnDefs = getColumnDefs();

  const inputField = (label, name, type, value, onChange, required = false) => {
    if (name === "password") {
      return (
        <label style={{ position: 'relative' }}>
          {label}
          <input
            type={showPassword ? "text" : "password"}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            style={{ ...inputStyle }}
          />
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              // transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#888',
              fontSize: 18,
            }}
            tabIndex={0}
            role="button"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </label>
      );
    }
    return (
      <label>
        {label}
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          style={inputStyle}
        />
      </label>
    );
  }

  const updateUserData = async (id, editedData, sponserUserId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${ADMIN_BASE_URL}/adminapi/user/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: editedData,
      });

      const result = await response.json();
      if (!response.ok) {
        alert(result.message || "Failed to update user");
        setLoading(false);
        return;
      }
      refreshUsers();
      setShowModal(false);
      alert("✅ User updated successfully!");
    } catch (error) {
      console.error("Error updating user:", error);
      alert("❌ Error updating user. Please try again.");
    } finally {
      setLoading(false);
    }
  }
  return (
    <Layout>
      <div className="userlist-container">
        <div className='userlist-header'>
          <h2 className="userlist-heading" style={{ marginTop: '20px' }}>
            {isAdminUser && "User Lists"}
          </h2>

        </div>
        {/* Admin Tabs */}
        {isAdminUser && (
          <div style={{
            display: 'flex',
            gap: '8px',
            marginBottom: '24px',
            borderBottom: '1px solid #e0e0e0',
            paddingBottom: '8px',

          }}>
            <button
              onClick={() => setActiveTab('all')}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '6px 6px 0 0',
                backgroundColor: activeTab === 'all' ? '#1976d2' : '#f5f5f5',
                color: activeTab === 'all' ? '#fff' : '#333',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderBottom: activeTab === 'all' ? '3px solid #1976d2' : '3px solid transparent'
              }}
            >
              All Users ({getUserCounts().all})
            </button>
            {isAdminUser && (
              <button
                onClick={() => setActiveTab('ai2')}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px 6px 0 0',
                  backgroundColor: activeTab === 'ai2' ? '#1976d2' : '#f5f5f5',
                  color: activeTab === 'ai2' ? '#fff' : '#333',
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  borderBottom: activeTab === 'ai2' ? '3px solid #1976d2' : '3px solid transparent'
                }}
              >
                Ai<sup>2</sup> Attendees ({getUserCounts().ai2})
              </button>
            )}
            <button
              onClick={() => setActiveTab('free')}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '6px 6px 0 0',
                backgroundColor: activeTab === 'free' ? '#1976d2' : '#f5f5f5',
                color: activeTab === 'free' ? '#fff' : '#333',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderBottom: activeTab === 'free' ? '3px solid #1976d2' : '3px solid transparent'
              }}
            >
              Free Members ({getUserCounts().free})
            </button>
            <button
              onClick={() => setActiveTab('verify')}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '6px 6px 0 0',
                backgroundColor: activeTab === 'verify' ? '#1976d2' : '#f5f5f5',
                color: activeTab === 'verify' ? '#fff' : '#333',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                borderBottom: activeTab === 'verify' ? '3px solid #1976d2' : '3px solid transparent'
              }}
            >
              VERIFY PAYMENT ({getUserCounts().verify})
            </button>
          </div>
        )}

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="ag-theme-alpine" style={{ width: '100%' }}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1.5rem',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                marginBottom: '24px',
                fontFamily: 'Segoe UI, sans-serif',
              }}
            >
              {/* Search Input */}
              {/* <div style={{ flexGrow: 1, maxWidth: 300 }}>
                <label
                  htmlFor="search"
                  style={{
                    display: 'block',
                    marginBottom: 6,
                    fontSize: 14,
                    color: '#37474f',
                    fontWeight: 600,
                  }}
                >
                  Search
                </label>
                <input
                  id="search"
                  type="text"
                  placeholder="Search"
                  value={searchText}
                  onChange={e => {
                    setSearchText(e.target.value);
                    if (gridRef.current?.api?.setQuickFilter) {
                      gridRef.current.api.setQuickFilter(e.target.value);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: 6,
                    border: '1.5px solid #90a4ae',
                    fontSize: 15,
                    outline: 'none',
                  }}
                />
              </div> */}

              {/* From Date - Only for Admin Users */}
              {isAdminUser && (
                <div>
                  <label
                    htmlFor="fromDate"
                    style={{
                      display: 'block',
                      marginBottom: 6,
                      fontSize: 14,
                      color: '#37474f',
                      fontWeight: 600,
                    }}
                  >
                    From
                  </label>
                  <input
                    id="fromDate"
                    type="date"
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                    style={{
                      padding: '10px 14px',
                      borderRadius: 6,
                      border: '1.5px solid #90a4ae',
                      fontSize: 15,
                      width: 180,
                      outline: 'none',
                    }}
                  />
                </div>
              )}

              {/* To Date - Only for Admin Users */}
              {isAdminUser && (
                <div>
                  <label
                    htmlFor="toDate"
                    style={{
                      display: 'block',
                      marginBottom: 6,
                      fontSize: 14,
                      color: '#37474f',
                      fontWeight: 600,
                    }}
                  >
                    To
                  </label>
                  <input
                    id="toDate"
                    type="date"
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                    style={{
                      padding: '10px 14px',
                      borderRadius: 6,
                      border: '1.5px solid #90a4ae',
                      fontSize: 15,
                      width: 180,
                      outline: 'none',
                    }}
                  />
                </div>
              )}

              {isAdminUser && showModals && (
                <PasswordModal
                  onClose={() => setShowModals(false)}
                  onConfirm={handleConfirmPassword}
                  username={revokeUsername}
                  email={revokeEmail}
                />
              )}
              {/* Export Button - Only for Admin Users */}
              {isAdminUser && (
                <div>
                  <label style={{ display: 'block', marginBottom: 6, opacity: 0 }}>Export</label>
                  <button
                    onClick={handleExportByDateRange}
                    style={{
                      padding: '11px 20px',
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      fontWeight: 600,
                      fontSize: 15,
                      cursor: 'pointer',
                      width: 120,
                    }}
                  >
                    Export
                  </button>
                </div>
              )}
            </div>

            {isAdminUser && (
              <div style={{ width: "100%" }}>
                <div className="ag-theme-alpine">
                  <AgGridReact
                    ref={gridRef}
                    onGridReady={params => {
                      gridRef.current = params;
                    }}
                    quickFilterText={searchText}
                    theme="legacy"
                    rowData={filteredUsers}
                    columnDefs={columnDefs}
                    pagination={true}
                    animateRows={true}
                    paginationPageSize={1000}
                    paginationPageSizeSelector={[20, 50, 100, 500, 1000]}
                    suppressHorizontalScroll={false}
                    suppressRowClickSelection={true}
                    rowSelection="single"
                    domLayout="autoHeight"
                    context={{
                      handleView,
                      handleDelete,
                      handleEditRefer,
                      allUsers: activeTab === 'ai2' ? ai2Users : users,
                    }}
                  // onCellMouseOver={onCellMouseOver}
                  // onCellMouseOut={onCellMouseOut}
                  // pagination={false} 
                  //onRowClicked={(event) => handleRowClick(event.data)}

                  />

                  {editUser && (
                    <Modal onClose={() => setEditUser(null)} title="Edit User" onSubmit={handleEditFormSubmit}>
                      {inputField("Username", "user_name", "text", editForm.user_name, handleEditFormChange, true)}
                      {inputField("First Name", "first_name", "text", editForm.first_name, handleEditFormChange, true)}
                      {inputField("Last Name", "last_name", "text", editForm.last_name, handleEditFormChange, true)}
                      {inputField("Phone Number", "phone_number", "text", editForm.phone_number, handleEditFormChange)}
                      {inputField("Email", "email", "email", editForm.email, handleEditFormChange, true)}
                      {inputField("Password", "password", "password", editForm.password, handleEditFormChange)}
                    </Modal>
                  )}
                </div>
              </div>
            )}
          </div>

        )}
        {/* Admin-specific TransactionPopup */}
        {isAdminUser && (
          <TransactionPopup
            open={popupOpen}
            onClose={() => setPopupOpen(false)}
            transaction={popupTransaction}
            onConfirm={handleConfirm}
            canConfirm={popupCanConfirm}
            allUsers={users}
            currentUser={users?.find(u => u.id === popupUserId)}
            onSaveRefer={handleSaveRefer}
            savingRefer={savingRefer}
          />
        )}
      </div>
      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        data={selectedRowData}
        onSubmit={updateUserData}
      />

      {/* AI2 USER MODAL */}
      <Ai2CustomModal
        show={showAi2Modal}
        onClose={() => setShowAi2Modal(false)}
        data={selectedRowData}
        onSuccess={refreshUsers}
      />

      {/* Admin-specific Manual Confirm Modal */}
      {isAdminUser && manualConfirmOpen && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ maxWidth: 400 }}>
            <h3>Manual Payment Confirmation</h3>
            <p>Do you want to manually confirm the payment for this user?</p>
            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
              <button
                style={{
                  background: "#43e97b",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 24px",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                }}
                onClick={async () => {
                  // Call your manual confirm API here
                  await handleConfirmManual(manualConfirmUserId);
                  setManualConfirmOpen(false);
                }}
              >
                Yes
              </button>
              <button
                style={{
                  background: "#e53935",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 24px",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                }}
                onClick={() => setManualConfirmOpen(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Admin-specific Edit Refer Modal */}
      {isAdminUser && editReferOpen && (
        <div className="popup-overlay"
        >
          <div className="popup-content" >
            <h2 style={{ fontSize: '20px', marginBottom: '16px', color: '#333' }}>
              Edit <span style={{ color: '#1976d2' }}>"Referred By"</span> User
            </h2>

            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <p style={{ margin: '4px 0', fontWeight: 600 }}>
                👤 User Name: <span style={{ fontWeight: 400 }}>{editReferUser?.user_name}</span>
              </p>
              <p style={{ margin: '4px 0', fontWeight: 600 }}>
                📧 Email: <span style={{ fontWeight: 400 }}>{editReferUser?.email}</span>
              </p>
            </div>

            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600, fontSize: 14 }}>
              Select Referred By
            </label>
            <select
              value={newReferId}
              onChange={e => setNewReferId(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: '8px',
                border: '1.5px solid #90a4ae',
                marginBottom: '24px',
                fontSize: 15,
              }}
            >
              <option value="">Select Referred By</option>
              {users
                .filter(u => u && u.id !== editReferUser?.id && u.user_name)
                .sort((a, b) => a.user_name.localeCompare(b.user_name))
                .map(u => (
                  <option key={u.id} value={u.id}>
                    {u.user_name} ({u.email})
                  </option>
                ))}
            </select>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <button
                onClick={handleSaveReferEdit}
                disabled={!newReferId || savingReferEdit}
                style={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: savingReferEdit ? "not-allowed" : "pointer",
                  opacity: savingReferEdit ? 0.7 : 1,
                  transition: '0.2s'
                }}
              >
                {savingReferEdit ? "Saving..." : "Save"}
              </button>
              <button
                onClick={() => setEditReferOpen(false)}
                style={{
                  backgroundColor: "#e0e0e0",
                  color: "#333",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: "pointer",
                  transition: '0.2s'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Admin-specific Referred Users Modal */}
      {isAdminUser && referredUsersOpen && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ maxWidth: 800 }}>
            <h3>
              Users referred by: <span style={{ color: "#1976d2" }}>{referredByUser?.user_name}</span>
            </h3>
            {referredUsersList.length === 0 ? (
              <p>No referred users.</p>
            ) : (
              <div className="referred-users-table-wrapper">
                <table className="referred-users-table">
                  <thead>
                    <tr>
                      <th>User Name</th>
                      <th>Email</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referredUsersList.map(u => (
                      <tr key={u.id}>
                        <td>{u.user_name}</td>
                        <td>{u.email}</td>
                        <td>{u.first_name}</td>
                        <td>{u.last_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ marginTop: 24, textAlign: "right" }}>
              <button
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 24px",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                }}
                onClick={() => setReferredUsersOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

    </Layout>
  );

}

const Modal = ({ children, onClose, title, onSubmit }) => (
  <div style={modalOverlay} onClick={onClose}>
    <form onClick={(e) => e.stopPropagation()} onSubmit={onSubmit} style={modalBox}>
      <h3>{title}</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>{children}</div>
      <div style={{ display: 'flex', gap: 12, marginTop: 18 }}>
        <button type="submit" style={submitButtonStyle('#1976d2', '#fff')}>Submit</button>
        <button type="button" onClick={onClose} style={submitButtonStyle('#e0e0e0', '#333')}>Cancel</button>
      </div>
    </form>
  </div>
);


const inputStyle = {
  width: '100%',
  padding: 8,
  borderRadius: 6,
  border: '1.5px solid #90a4ae',
};

const iconBtnStyle = (color) => ({
  background: 'none',
  border: 'none',
  color,
  cursor: 'pointer',
  fontSize: '16px',
});


const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.3)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const submitButtonStyle = (bg, color) => ({
  padding: '10px 24px',
  backgroundColor: bg,
  color,
  border: 'none',
  borderRadius: 6,
  fontWeight: 600,
  fontSize: 15,
  cursor: 'pointer',
});

const modalBox = {
  background: '#fff',
  padding: 32,
  borderRadius: 10,
  minWidth: 350,
  maxWidth: 400,
  width: '90%',
  boxShadow: '0 8px 32px rgba(44,62,80,0.18)',
  display: 'flex',
  flexDirection: 'column',
};


export default UserList;


const TransactionPopup = ({
  open,
  onClose,
  transaction,
  onConfirm,
  canConfirm,
  allUsers,
  currentUser,
  onSaveRefer,
  savingRefer,
}) => {
  const [selectedReferId, setSelectedReferId] = useState('');
  const [editMode, setEditMode] = useState(false);

  // alert("currentUser: " + JSON.stringify(allUsers));

  useEffect(() => {
    setSelectedReferId('');
    if (!open) {
      setEditMode(false);
    }
  }, [open]);

  if (!open) return null;

  const isPaid = currentUser?.is_confirmation === 1;


  // Find the referred user if user_refer_id is set
  const referredUser = allUsers?.find(u => u.id === currentUser?.ds_id);
  // alert("referredUser: " + JSON.stringify(referredUser)); 

  return (

    <div className="popup-overlay">
      <div className="popup-content">
        <div className="referral-section">
          <h4 className="referral-title">User Information</h4>
          <div className="referral-details">
            <div className="referral-field">
              <span className="label">VIRON Username:</span>
              <span className="value">{currentUser?.user_name}</span>
            </div>

            <div className="referral-field">
              <span className="label">First Name:</span>
              <span className="value">{currentUser?.first_name}</span>
            </div>
            <div className="referral-field">
              <span className="label">Last Name:</span>
              <span className="value">{currentUser?.last_name}</span>
            </div>
            <div className="referral-field">
              <span className="label">User Email:</span>
              <span className="value">{currentUser?.email}</span>
            </div>
          </div>
        </div>

        <h3>Transaction Details</h3>
        <p><strong>Transaction Type:</strong> {transaction?.type || "—"}</p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 8,
          maxWidth: 800, // or your popup width
          flexWrap: 'wrap'
        }}>
          <strong style={{ minWidth: 140 }}>Transaction ID#:</strong>
          <span
            style={{
              fontFamily: 'monospace',
              fontSize: 16,
              marginRight: 8,
              maxWidth: 720,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              wordBreak: 'break-all',
              verticalAlign: 'middle'
            }}
            title={transaction?.value}
          >
            {transaction?.value || "—"}
          </span>
          {transaction?.value && (
            <button
              onClick={() => {
                navigator.clipboard.writeText(transaction.value);
                toast.success("Transaction ID copied!");
              }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                marginLeft: 4,
              }}
              title="Copy Transaction ID"
            >
              <FiCopy size={16} color="#1976d2" />
            </button>
          )}
        </div>
        <p>
          <strong>Transaction Time/Date:</strong>{' '}
          {transaction?.created_at
            ? new Date(transaction.created_at).toLocaleString()
            : '—'}
        </p>


        {isPaid && (
          <div className="referral-section">
            <h4 className="referral-title">DESIGNATED SPONSOR (DS) Assignment</h4>
            <div style={{ marginTop: 20 }}>

              {/* <h4>Referred By</h4> */}
              {currentUser?.ds_id && !editMode ? (
                <div className="referral-card">
                  <div className="referral-field">
                    <span className="label">VIRON Username:</span>
                    <span className="value">{referredUser?.user_name}</span>
                  </div>
                  <div className="referral-field">
                    <span className="label">User Email:</span>
                    <span className="value">{referredUser?.email}</span>
                  </div>
                  <div className="referral-field">
                    <span className="label">First Name:</span>
                    <span className="value">{referredUser?.first_name}</span>
                  </div>
                  <div className="referral-field">
                    <span className="label">Last Name:</span>
                    <span className="value">{referredUser?.last_name}</span>
                  </div>
                  <button
                    style={{
                      background: "#43e97b",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      padding: "7px 18px",
                      fontWeight: 600,
                      fontSize: 15,
                      cursor: "pointer",
                      // opacity: disabled ? 0.7 : 1,
                    }}
                    className="edit-btn"
                    // style={}
                    onClick={() => setEditMode(true)}
                  >
                    Edit
                  </button>
                </div>
              ) : (
                <>
                  <select
                    value={selectedReferId}
                    onChange={e => setSelectedReferId(e.target.value)}
                    style={{ padding: 8, borderRadius: 6, width: '100%', marginBottom: 10 }}
                  >
                    <option value="">Select Designated Sponsor</option>
                    {allUsers
                      .filter(u => (u.id !== currentUser.id && u.is_confirmation === 1))
                      .map(u => (
                        <option key={u.id} value={u.id}>
                          {u.user_name} ({u.email})
                        </option>
                      ))}
                  </select>
                  <button
                    className="confirm-btn"
                    onClick={() => onSaveRefer(selectedReferId, true)}
                    disabled={!selectedReferId || savingRefer}
                  >
                    {savingRefer ? "Saving..." : "Assign Designated Sponsor"}
                  </button>
                  {currentUser?.ds_id && (
                    <button
                      className="close-btn"
                      style={{ marginLeft: 10 }}
                      onClick={() => setEditMode(false)}
                    >
                      Cancel
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        )}
        <div style={{ marginTop: 20 }}>
          {canConfirm && (
            <button className="confirm-btn-verify" onClick={onConfirm}>Verify Payment</button>
          )}
          <button className="close-btn" onClick={onClose} style={{ marginLeft: 10 }}>Close</button>
        </div>
      </div>
    </div>
  );
};


